import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/logo.png';
import _imports_1 from '../assets/icon/MyAsset.svg';
import _imports_2 from '../assets/icon/Deposit.svg';
import _imports_3 from '../assets/icon/Withdraw.svg';
import _imports_4 from '../assets/icon/Transfer.svg';
import _imports_5 from '../assets/icon/MyOrder.svg';
import _imports_6 from '@/assets/icon/Account.svg';
import _imports_7 from '../assets/icon/PersonalInfo.svg';
import _imports_8 from '../assets/icon/ModifyPassword.svg';
import _imports_9 from '../assets/icon/AccountVerify.png';
import _imports_10 from '../assets/icon/Logout.svg';
const _withScopeId = n => (_pushScopeId("data-v-54341078"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header-nav"
};
const _hoisted_2 = {
  style: {
    "width": "100%",
    "display": "flex",
    "justify-content": "space-between",
    "padding": "0 32px"
  }
};
const _hoisted_3 = {
  class: "header-l"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  class: "header-r"
};
const _hoisted_7 = {
  key: 0,
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_8 = {
  class: "header-email"
};
const _hoisted_9 = {
  class: "info-menu"
};
const _hoisted_10 = {
  class: "info-menu-content"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}, null, -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5
}, null, -1));
const _hoisted_16 = {
  class: "header-email"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "",
  style: {
    "width": "20px",
    "margin-left": "10px"
  }
}, null, -1));
const _hoisted_18 = {
  class: "info-menu"
};
const _hoisted_19 = {
  class: "info-menu-content"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7
}, null, -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8
}, null, -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9
}, null, -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10
}, null, -1));
const _hoisted_24 = {
  key: 1,
  class: "user-option"
};
const _hoisted_25 = {
  key: 0,
  class: "ICLightMode_svg__icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#1D1D1D"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M554.656 85.312a42.656 42.656 0 00-85.312 0v64a42.656 42.656 0 0085.312 0v-64zm-374.56 94.784a42.656 42.656 0 0160.352 0l45.248 45.248a42.656 42.656 0 11-60.352 60.352l-45.248-45.248a42.656 42.656 0 010-60.352zM42.656 512c0-23.552 19.104-42.656 42.656-42.656h64a42.656 42.656 0 010 85.312h-64A42.656 42.656 0 0142.656 512zm243.072 286.592a42.656 42.656 0 10-60.352-60.352l-45.248 45.248a42.656 42.656 0 1060.352 60.352l45.248-45.248zm452.544-60.256a42.656 42.656 0 0160.352 0l45.248 45.248a42.656 42.656 0 11-60.352 60.352l-45.248-45.248a42.656 42.656 0 010-60.352zm136.384-269.024a42.656 42.656 0 000 85.312h64a42.656 42.656 0 000-85.312h-64zM843.872 180.16a42.656 42.656 0 010 60.352l-45.248 45.248a42.656 42.656 0 11-60.352-60.352l45.248-45.248a42.656 42.656 0 0160.352 0z"
}, null, -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M225.536 512A286.496 286.496 0 11512 798.496 286.464 286.464 0 01225.536 512zM512 310.848a201.152 201.152 0 100 402.304 201.152 201.152 0 000-402.304zm42.656 563.872a42.656 42.656 0 00-85.312 0v64a42.656 42.656 0 0085.312 0v-64z"
}, null, -1));
const _hoisted_28 = [_hoisted_26, _hoisted_27];
const _hoisted_29 = {
  key: 1,
  class: "ICDarkMode_svg__icon",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#F3F3F3"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M416.16 179.392c-140.8 33.568-245.504 160.192-245.504 311.296 0 176.736 143.264 320 320 320 151.072 0 277.696-104.704 311.296-245.504a273.44 273.44 0 01-385.76-385.76zM85.344 490.656c0-223.872 181.472-405.344 405.344-405.344 28.096 0 55.552 2.848 82.08 8.32a42.656 42.656 0 012.144 83.072A188.128 188.128 0 10804.576 406.4a42.656 42.656 0 0183.072 2.144c5.472 26.528 8.32 54.016 8.32 82.08 0 223.872-181.472 405.344-405.344 405.344S85.28 714.496 85.28 490.624z"
}, null, -1));
const _hoisted_31 = [_hoisted_30];
const _hoisted_32 = {
  class: "language"
};
const _hoisted_33 = {
  class: "title"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-en"
}, null, -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "English", -1));
const _hoisted_36 = [_hoisted_34, _hoisted_35];
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-tw"
}, null, -1));
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "繁體", -1));
const _hoisted_39 = [_hoisted_37, _hoisted_38];
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-hin"
}, null, -1));
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "हिन्दी", -1));
const _hoisted_42 = [_hoisted_40, _hoisted_41];
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-fr"
}, null, -1));
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Francés", -1));
const _hoisted_45 = [_hoisted_43, _hoisted_44];
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-span"
}, null, -1));
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Español", -1));
const _hoisted_48 = [_hoisted_46, _hoisted_47];
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-de"
}, null, -1));
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Deutsch", -1));
const _hoisted_51 = [_hoisted_49, _hoisted_50];
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-it"
}, null, -1));
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Italiano", -1));
const _hoisted_54 = [_hoisted_52, _hoisted_53];
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-th"
}, null, -1));
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "แบบไทย", -1));
const _hoisted_57 = [_hoisted_55, _hoisted_56];
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-pt"
}, null, -1));
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Português", -1));
const _hoisted_60 = [_hoisted_58, _hoisted_59];
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-tr"
}, null, -1));
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Türkçe", -1));
const _hoisted_63 = [_hoisted_61, _hoisted_62];
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-kr"
}, null, -1));
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "한국인", -1));
const _hoisted_66 = [_hoisted_64, _hoisted_65];
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-jp"
}, null, -1));
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "日本語", -1));
const _hoisted_69 = [_hoisted_67, _hoisted_68];
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-ru"
}, null, -1));
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pусский", -1));
const _hoisted_72 = [_hoisted_70, _hoisted_71];
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-ar"
}, null, -1));
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "اللغة العربية", -1));
const _hoisted_75 = [_hoisted_73, _hoisted_74];
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flag flag-nl"
}, null, -1));
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Dutch", -1));
const _hoisted_78 = [_hoisted_76, _hoisted_77];
import { computed, onBeforeMount, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import store from '@/store';
import { useI18n } from "vue-i18n";
import { message } from 'ant-design-vue';
import { GlobalOutlined, DownOutlined } from '@ant-design/icons-vue';
import { getPledgeLoanCopy } from '@/util/pledgeLoan';

// import { Swiper, SwiperSlide } from "swiper/vue"
// import { Autoplay } from "swiper"
// import "swiper/css"

// const modules = [Autoplay]

export default {
  __name: 'HeaderNav',
  emits: ["changeColor"],
  setup(__props, {
    emit
  }) {
    const router = useRouter();
    const route = useRoute();
    const isLight = ref(true);
    const languageModel = ref(false);
    onBeforeMount(() => {
      if (localStorage.getItem('isLight') == undefined || localStorage.getItem('isLight') == null) {
        localStorage.setItem('isLight', true);
      } else {
        isLight.value = Boolean(localStorage.getItem('isLight') == 'true');
      }
    });
    const changeColor = () => {
      emit('changeColor', isLight.value);
    };
    const {
      setLocaleMessage,
      locale,
      t
    } = useI18n();
    const pledgeCopy = computed(() => getPledgeLoanCopy(t));
    const langSelcet = lang => {
      try {
        localStorage.setItem('pcsetlang', lang);
        store.commit('langChange', lang);
        const msg = require(`@/language/lang/${lang}`).default;
        setLocaleMessage(lang, msg);
        locale.value = lang;
      } catch (err) {
        console.warn(err);
      }
      languageModel.value = false;
    };
    const goToPage = name => {
      if (name === route.name) {
        return;
      }
      router.push({
        name: name
      });
    };
    const logout = () => {
      store.commit('tokenChange', '');
      store.commit('emailChange', '');
      localStorage.removeItem('pcstore_info');
      message.success(t('logoutSuccess'));
      router.replace({
        name: 'login'
      });
    };
    const navClass = name => {
      if (route.meta.header === name) {
        return ['nav-item', 'nav-active'];
      }
      return ['nav-item'];
    };
    const goToIEO = () => {
      router.push(`/ieo/ERS`);
      return;
    };
    return (_ctx, _cache) => {
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "logo-view",
        onClick: _cache[0] || (_cache[0] = $event => goToPage('home'))
      }, _hoisted_5), _createElementVNode("div", {
        class: _normalizeClass(navClass('home')),
        onClick: _cache[1] || (_cache[1] = $event => goToPage('home'))
      }, _toDisplayString(_unref(t)('home')), 3), _createElementVNode("div", {
        class: _normalizeClass(navClass('spotTrade')),
        onClick: _cache[2] || (_cache[2] = $event => goToPage('spotTrade'))
      }, _toDisplayString(_unref(t)('currency')), 3), _createElementVNode("div", {
        class: _normalizeClass(navClass('contract')),
        onClick: _cache[3] || (_cache[3] = $event => goToPage('contract'))
      }, _toDisplayString(_unref(t)('contract')), 3), _createElementVNode("div", {
        class: _normalizeClass(navClass('commodities')),
        onClick: _cache[4] || (_cache[4] = $event => goToPage('commodities'))
      }, _toDisplayString(_unref(t)('commodities')), 3), _createElementVNode("div", {
        class: _normalizeClass(navClass('indices')),
        onClick: _cache[5] || (_cache[5] = $event => goToPage('indices'))
      }, _toDisplayString(_unref(t)('indices')), 3), _createElementVNode("div", {
        class: _normalizeClass(navClass('ieo')),
        onClick: goToIEO
      }, _toDisplayString(_unref(t)('ieoBuy')), 3), _createElementVNode("div", {
        class: _normalizeClass([...navClass('pledgeLoan'), 'nav-highlight']),
        onClick: _cache[6] || (_cache[6] = $event => goToPage('pledgeLoan'))
      }, _toDisplayString(_unref(pledgeCopy).name), 3)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        class: "option",
        onClick: _cache[7] || (_cache[7] = $event => languageModel.value = true)
      }, [_createVNode(_unref(GlobalOutlined))]), _unref(store).state.token !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_a_dropdown, {
        placement: "bottomRight"
      }, {
        overlay: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
          class: "item",
          onClick: _cache[8] || (_cache[8] = $event => goToPage('wallet'))
        }, [_hoisted_11, _createElementVNode("div", null, _toDisplayString(_unref(t)('myAssets')), 1)]), _createElementVNode("div", {
          class: "item",
          onClick: _cache[9] || (_cache[9] = $event => goToPage('recharge'))
        }, [_hoisted_12, _createElementVNode("div", null, _toDisplayString(_unref(t)('recharge')), 1)]), _createElementVNode("div", {
          class: "item",
          onClick: _cache[10] || (_cache[10] = $event => goToPage('withdraw'))
        }, [_hoisted_13, _createElementVNode("div", null, _toDisplayString(_unref(t)('withdraw')), 1)]), _createElementVNode("div", {
          class: "item",
          onClick: _cache[11] || (_cache[11] = $event => goToPage('transfer'))
        }, [_hoisted_14, _createElementVNode("div", null, _toDisplayString(_unref(t)('transfer')), 1)]), _createElementVNode("div", {
          class: "item",
          onClick: _cache[12] || (_cache[12] = $event => goToPage('order'))
        }, [_hoisted_15, _createElementVNode("div", null, _toDisplayString(_unref(t)('order')), 1)])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createTextVNode(_toDisplayString(_unref(t)('assetsManagement')) + " ", 1), _createVNode(_unref(DownOutlined), {
          style: {
            "margin-left": "10px",
            "font-size": "16px"
          }
        })])]),
        _: 1
      }), _createVNode(_component_a_dropdown, {
        placement: "bottomRight"
      }, {
        overlay: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
          class: "item",
          onClick: _cache[13] || (_cache[13] = $event => goToPage('userInfo'))
        }, [_hoisted_20, _createElementVNode("div", null, _toDisplayString(_unref(t)('personalInfo')), 1)]), _createElementVNode("div", {
          class: "item",
          onClick: _cache[14] || (_cache[14] = $event => goToPage('loginPwd'))
        }, [_hoisted_21, _createElementVNode("div", null, _toDisplayString(_unref(t)('modifyPassword')), 1)]), _createElementVNode("div", {
          class: "item",
          onClick: _cache[15] || (_cache[15] = $event => goToPage('userAuth'))
        }, [_hoisted_22, _createElementVNode("div", null, _toDisplayString(_unref(t)('userAuth')), 1)]), _createElementVNode("div", {
          class: "item",
          onClick: logout
        }, [_hoisted_23, _createElementVNode("div", null, _toDisplayString(_unref(t)('logout')), 1)])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createTextVNode(_toDisplayString(_unref(store).state.email) + " ", 1), _createVNode(_unref(DownOutlined), {
          style: {
            "margin-left": "10px",
            "font-size": "16px"
          }
        }), _hoisted_17])]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("span", {
        class: "btn",
        onClick: _cache[16] || (_cache[16] = $event => goToPage('login'))
      }, _toDisplayString(_unref(t)('login')), 1), _createElementVNode("span", {
        class: "btn register",
        onClick: _cache[17] || (_cache[17] = $event => goToPage('register'))
      }, _toDisplayString(_unref(t)('register')), 1)])), _createElementVNode("div", {
        class: "option",
        onClick: _cache[18] || (_cache[18] = $event => {
          isLight.value = !isLight.value;
          changeColor();
        })
      }, [isLight.value ? (_openBlock(), _createElementBlock("svg", _hoisted_25, _hoisted_28)) : (_openBlock(), _createElementBlock("svg", _hoisted_29, _hoisted_31))])])])]), _createVNode(_component_a_modal, {
        visible: languageModel.value,
        "onUpdate:visible": _cache[34] || (_cache[34] = $event => languageModel.value = $event),
        footer: null
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('homeremind63')), 1), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'en'
          }]),
          onClick: _cache[19] || (_cache[19] = $event => langSelcet('en'))
        }, _hoisted_36, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'tc'
          }]),
          onClick: _cache[20] || (_cache[20] = $event => langSelcet('tc'))
        }, _hoisted_39, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'hin'
          }]),
          onClick: _cache[21] || (_cache[21] = $event => langSelcet('hin'))
        }, _hoisted_42, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'fr'
          }]),
          onClick: _cache[22] || (_cache[22] = $event => langSelcet('fr'))
        }, _hoisted_45, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'span'
          }]),
          onClick: _cache[23] || (_cache[23] = $event => langSelcet('span'))
        }, _hoisted_48, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'de'
          }]),
          onClick: _cache[24] || (_cache[24] = $event => langSelcet('de'))
        }, _hoisted_51, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'it'
          }]),
          onClick: _cache[25] || (_cache[25] = $event => langSelcet('it'))
        }, _hoisted_54, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'th'
          }]),
          onClick: _cache[26] || (_cache[26] = $event => langSelcet('th'))
        }, _hoisted_57, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'pt'
          }]),
          onClick: _cache[27] || (_cache[27] = $event => langSelcet('pt'))
        }, _hoisted_60, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'tr'
          }]),
          onClick: _cache[28] || (_cache[28] = $event => langSelcet('tr'))
        }, _hoisted_63, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'kr'
          }]),
          onClick: _cache[29] || (_cache[29] = $event => langSelcet('kr'))
        }, _hoisted_66, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'jp'
          }]),
          onClick: _cache[30] || (_cache[30] = $event => langSelcet('jp'))
        }, _hoisted_69, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'ru'
          }]),
          onClick: _cache[31] || (_cache[31] = $event => langSelcet('ru'))
        }, _hoisted_72, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'ar'
          }]),
          onClick: _cache[32] || (_cache[32] = $event => langSelcet('ar'))
        }, _hoisted_75, 2), _createElementVNode("div", {
          class: _normalizeClass(["select-item", {
            choose: _unref(store).state.lang === 'nl'
          }]),
          onClick: _cache[33] || (_cache[33] = $event => langSelcet('nl'))
        }, _hoisted_78, 2)])]),
        _: 1
      }, 8, ["visible"])], 64);
    };
  }
};